// extracted by mini-css-extract-plugin
module.exports = {"main":"button-panel_main__3s6WV","btns":"button-panel_btns__1B2Vm"};